// extracted by mini-css-extract-plugin
module.exports = {"labelHeader":"index-module__labelHeader___3GpsV","colorRequired":"index-module__colorRequired___rARgd"};